import cancelIcon from "../../../assets/images/cancel-btn.svg";

/** Presentational phone editor; persistence remains owned by the page. */
export function ChangePhoneNumberModal({
  isOpen,
  phoneNumber,
  onPhoneNumberChange,
  onClose,
  onSubmit,
  isSubmitting,
}) {
  if (!isOpen) return null;

  return (
    <div className="popup holidayPopup AddAppointmentModal">
      <div className="popup-content">
        <button
          aria-label="Close phone number editor"
          className="cancelBtn"
          onClick={onClose}
          type="button"
        >
          <img src={cancelIcon} alt="" />
        </button>

        <div className="addNursePopup addAppointment">
          <h2 className="nurseHdn">Change Phone Number</h2>
          <div className="patientAddBox">
            <ul className="addPatientList">
              <li>
                <label htmlFor="consultation-new-phone">New Phone Number</label>
                <input
                  id="consultation-new-phone"
                  type="number"
                  placeholder="Enter new phone number"
                  value={phoneNumber}
                  onChange={(event) =>
                    onPhoneNumberChange(event.target.value)
                  }
                />
              </li>
              <li>
                <button
                  disabled={isSubmitting}
                  onClick={onSubmit}
                  type="button"
                >
                  {isSubmitting ? "Please wait..." : "Edit"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
